import React, { useEffect, useState } from "react";
import cx from "classnames";
import maskPhone from "helpers/handlePhoneMask";

type Props = {
  placeholder: string;
  value: string;
  placeholderStyle?: any;
  label?: string;
  labelStyle?: any;
  isHelp?: boolean;
  helpText?: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

const PhoneInputAuth: React.FC<Props> = ({
  placeholder,
  placeholderStyle,
  label,
  labelStyle,
  helpText,
  type = "text",
  isHelp,
  className,
  value,
  onChange,
  onBlur,
}): JSX.Element => {
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    setInputValue(maskPhone(value));
  }, [value]);

  return (
    <div className={cx("flex flex-col min-w-0", className)}>
      {label && (
        <span
          className="font-sora text-sm"
          style={{
            fontStyle: "normal",
            fontWeight: 400,
            color: "#A5A5A5",
          }}
        >
          {label}
        </span>
      )}
      <div className="flex flex-row">
        <input
          className={cx(
            "w-full h-14 text-sm font-sora",
            isHelp ? "border-bt-red my-1" : "my-2",
            placeholderStyle
          )}
          style={{
            background: "#FFFFFF",
            border: isHelp ? "2px solid #FD5B28" : "0.5px solid #8E8E8E",
            borderRadius: "4px",
          }}
          type={type}
          placeholder={placeholder}
          value={inputValue}
          onChange={onChange}
          onBlur={onBlur}
          autoComplete="off"
        />
      </div>
      {isHelp && helpText && (
        <div className="flex flex-row">
          <span className="font-nunito mt-1 text-xs text-bt-red">
            {helpText}
          </span>
        </div>
      )}
    </div>
  );
};

export default PhoneInputAuth;
